import { render, staticRenderFns } from "./Dynamic.vue?vue&type=template&id=d40f240e&scoped=true"
import script from "./Dynamic.vue?vue&type=script&lang=js"
export * from "./Dynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40f240e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d40f240e')) {
      api.createRecord('d40f240e', component.options)
    } else {
      api.reload('d40f240e', component.options)
    }
    module.hot.accept("./Dynamic.vue?vue&type=template&id=d40f240e&scoped=true", function () {
      api.rerender('d40f240e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/plugin/Dynamic.vue"
export default component.exports